import { Link } from "react-router-dom";

const TopCharts = ({topChartData}) => {
  return (
    <>
    <h1 className="text-3xl text-red-900 font-bold">Top Charts</h1>
    <div className="flex justify-center sm:justify-between align-items-center sm:flex-row flex-col bg-white/20 p-6 rounded-2xl gap-10 flex-wrap">
      
      <div> <h1>Most Recent Music</h1>
 {topChartData.recentMusic? 
        <ul className="space-y-2">
          {topChartData.recentMusic.map((list, i) => (
           <Link key={i}  to={`/admin/music/all/view-music/${list._id}`}> <li className="flex justify-between py-2">
              <span>{list.title || list.uploader?.username} {list.count && list.count}</span>
            </li></Link>
          ))}
        </ul>:<h1>No recent music to display</h1>}
</div>
      <div>
        <h1>Top Stream Music</h1>
        {topChartData.topStreams?    <ul className="space-y-2">
          {topChartData.topStreams.map((list, i) => (
           <Link key={i} to={`/user/my-profile/${list._id}`}> <li className="flex justify-between py-2">
              <span>{list.title} {list.uploader.username}</span>
            </li></Link>
          ))}
        </ul>:<h1>No top streams music to display</h1>}
        </div>
      <div> 
        <h1>Top Artiste</h1>
      {topChartData.topArtistes? 
        <ul className="space-y-2">
          {topChartData.topArtistes.map((list, i) => (
           <Link key={i} to={`/user/my-profile/${list.uploader.id}`}> <li  className="flex justify-between py-2">
              <span>{list.uploader?.username} {list.count}</span>
            </li></Link>
          ))}
        </ul>:<h1>No top artistes to display </h1>}
    </div>
    </div>
    </>
  );
};

export default TopCharts;
